import React, { useEffect } from "react";
import { Box, TextField, Typography, Button } from "@mui/material";
import { Controller, useForm } from "react-hook-form";

export interface FilterCuposClienteFormData {
  cuit: string;
  comercialName: string;
}

interface FilterCuposClienteProps {
  searchFilters?: FilterCuposClienteFormData | null;
  onCancel?: () => void;
  onFilter?: (data: FilterCuposClienteFormData) => void;
}

const FilterCuposCliente = ({
  searchFilters,
  onCancel,
  onFilter,
}: FilterCuposClienteProps) => {
  const { handleSubmit, control, reset } = useForm<FilterCuposClienteFormData>(
    {
      defaultValues: {
        cuit: "",
        comercialName: "",
      },
    },
  );

  useEffect(() => {
    if (searchFilters === null) {
      reset({
        cuit: "",
        comercialName: "",
      });
      return;
    }
    if (searchFilters) {
      reset({
        cuit: searchFilters.cuit || "",
        comercialName: searchFilters.comercialName || "",
      });
    }
  }, [searchFilters, reset]);

  const onSubmitHandler = (data: FilterCuposClienteFormData) => {
    onFilter?.(data);
  };

  const handleLimpiar = () => {
    reset({
      cuit: "",
      comercialName: "",
    });
    onCancel?.();
  };

  return (
    <form onSubmit={handleSubmit(onSubmitHandler)}>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          alignItems: "flex-end",
          mb: 3,
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ flex: "1 1 200px", minWidth: 180 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            CUIT
          </Typography>
          <Controller
            control={control}
            name="cuit"
            render={({ field }) => (
              <TextField
                {...field}
                size="small"
                fullWidth
                placeholder="Ej. 30-70921950-9"
              />
            )}
          />
        </Box>
        <Box sx={{ flex: "1 1 200px", minWidth: 180 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            Nombre comercial
          </Typography>
          <Controller
            control={control}
            name="comercialName"
            render={({ field }) => (
              <TextField
                {...field}
                size="small"
                fullWidth
                placeholder="Buscar por nombre comercial"
              />
            )}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
            justifyContent: "flex-end",
          }}
        >
          <Button variant="outlined" color="primary" onClick={handleLimpiar}>
            Limpiar
          </Button>
          <Button type="submit" variant="contained" color="primary">
            Buscar
          </Button>
        </Box>
      </Box>
    </form>
  );
};

export default FilterCuposCliente;
